import { CountUp } from "@/components/home/count-up";

const PROOF = [
  { v: 50, suffix: "+", label: "Products helped ship" },
  { v: 25, suffix: "+", label: "Teams worked with" },
  { v: 45000, suffix: "+", label: "Users migrated" },
];

/** Three numbers we can stand behind, straight after the work wall. */
export function Proof() {
  return (
    <section
      aria-labelledby="proof-h"
      className="relative mx-auto max-w-[1400px] border-t border-border/60 px-6 py-14 md:px-10 md:py-20"
    >
      <h2 id="proof-h" className="sr-only">
        By the numbers
      </h2>
      <dl className="grid gap-10 md:grid-cols-3 md:gap-0 md:divide-x md:divide-border/70">
        {PROOF.map((p, i) => (
          <div key={p.label} className={`flex flex-col ${i > 0 ? "md:pl-10" : ""}`}>
            <dt className="order-2 mt-3 text-base text-muted-foreground">{p.label}</dt>
            <dd
              className="order-1 font-display leading-none tracking-[-0.05em]"
              style={{ fontSize: "clamp(3rem, 6.5vw, 5.5rem)" }}
            >
              <CountUp end={p.v} suffix={p.suffix} />
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
